export default {
  appLayerConfigDebug: false
};